<template>
  <div>
    <div id="custom-header-bg" class="d-sm-down-none m-0">
      <img style="max-width: -webkit-fill-available;" src="../assets/img/bgProfile.png" />
      <div id="example" class="box-shadow-profile">
        <CRow>
          <CCol sm="1">
            <div class="image-div">
              <img
                v-if="studentProfileAuthorize == ''"
                style="border: 1px solid #eee; width: 60px; height: 60px; object-fit: cover;"
                src="../assets/img/default.png"
                class="grey lighten-2 mt-2"
              />

              <img
                v-else
                style="
                  border: 3px solid #ddd;
                  background: #fff;
                  width: 60px;
                  height: 60px;
                "
                :src="photoURL"
                class="grey lighten-2 mt-2"
              />
            </div>
          </CCol>
          <CCol sm="7">
            <h4 class="mt-2">
              <strong> {{ user.name }}</strong>
            </h4>
            <div class="small text-muted">{{ user.userType }}</div>
          </CCol>
          <CCol sm="4">
            <div class="mt-2">
               <CButton color="success">
            <span @click="GoToPageRegisterStudent">
              + Register New Student</span
            >
          </CButton>
            </div>
          </CCol>
        </CRow>
      </div>
    </div>

    <div class="d-sm-flex d-md-none" id="custom-header-bg-sm">
      <img style="max-width: 100%" src="../assets/img/bgProfile.png" />
      <div id="examplesm" class="box-shadow-profile" style="height:100px">
        <div class="row">
          <div style="width: 30%">
            <div class="ml-3">
              <img
                v-if="studentProfileAuthorize == ''"
                style="border: 1px solid #eee; width: 60px; height: 60px; object-fit: cover;"
                src="../assets/img/default.png"
                class="grey lighten-2 mt-2"
              />

              <img
                v-else
                style="
                  border: 3px solid #ddd;
                  background: #fff;
                  width: 60px;
                  height: 60px;
                "
                :src="photoURL"
                class="grey lighten-2 mt-2"
              />
            </div>
          </div>
          <div style="width: 70%">
            <h5 class="mt-2">
              <strong> {{ user.name }}</strong>
            </h5>
            <div class="small text-muted">{{ user.userType }}</div>
          </div>
          <div class="text-center" style="width: 100%">
               <CButton color="success">
            <span @click="GoToPageRegisterStudent">
              + Register New Student</span
            >
          </CButton>
          </div>
        </div>
      </div>
    </div>

    <CCol sm="12" class="m-0 p-0">
      <CRow>
        <CCol sm="4">
          <CCard class="custom-height-performance box-shadow-dashboard">
            <div class="p-3">
              <h5>Platform Setting</h5>
              <div class="small text-muted">ACCOUNT</div>
              <br />
              <CSwitch color="primary" checked shape="pill" size="sm" /> Allow
              to accept general notification on Apps
              <br />
              <CSwitch color="primary" shape="pill" size="sm" /> Allow class
              notification on Apps
              <br />
              <CSwitch color="primary" checked shape="pill" size="sm" /> Allow
              chat notification on Apps <br /><br />
              <div class="small text-muted">APPLICATION</div>
              <br />
              <CSwitch color="primary" checked shape="pill" size="sm" /> Want
              join webinar
              <br />
              <CSwitch color="primary" checked shape="pill" size="sm" />
              Monthly product updates
              <br />
              <CSwitch color="primary" checked shape="pill" size="sm" />
              Subscribe to newsletter
            </div>
          </CCard>
        </CCol>
        <CCol sm="4">
          <CCard class="custom-height-performance box-shadow-dashboard">
            <div class="p-3">
              <h5>Parent Information</h5>
              <div class="small text-muted">
                Write your profile info or any wishes for this platform to help
                you for us to understand further your interest...
              </div>
              <br /><br />
              <hr />
              <br />
              <CRow>
                <CCol sm="3">Full Name</CCol>
                <CCol sm="9"> : {{ studentProfile.userName }} </CCol>

                <CCol sm="3">Mobile</CCol>
                <CCol sm="9"> : {{ studentProfile.phoneNumber }} </CCol>

                <CCol sm="3">Email</CCol>
                <CCol sm="9"> : {{ studentProfile.userEmail }} </CCol>

                <CCol sm="3">Location</CCol>
                <CCol sm="9"> : Malaysia </CCol>

                <CCol sm="3">Social</CCol>
                <CCol sm="9"> : </CCol>
              </CRow>
            </div>
          </CCard>
        </CCol>
        <CCol sm="4">
          <CCard class="custom-height-performance box-shadow-dashboard">
            <div class="p-3">
              <h5>Students</h5>
              <CRow
                v-for="(item, index) in childs.Students"
                v-bind:key="item.Id"
              >
                <CCol sm="3">
                  <img
                    v-if="item.profileImagePath == null"
                    style="border: 1px solid #eee; width: 60px; height: 60px; object-fit: cover;"
                    src="../assets/img/default.png"
                    class="grey lighten-2 mt-2"
                  />

                  <img
                    v-else
                    style="
                      border: 3px solid #ddd;
                      background: #fff;
                      width: 60px;
                      height: 60px;
                       object-fit: cover;
                    "
                    :src="getPicChild(index)"
                    class="grey lighten-2 mt-2"
                  />
                </CCol>
                <CCol sm="9">
                  <div>
                    <span> {{ item.studentName }}</span>
                    <br />
                    <div class="small text-muted">{{ item.grade }}</div>
                  </div>
                </CCol>
              </CRow>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CCol>

    <CCol sm="12" class="m-0 p-0">
      <CRow>
        <CCol sm="12">
          <CCard class="box-shadow-dashboard">
            <h6 class="ml-3 mt-3"><strong>Offers</strong></h6>
            <p class="ml-3">List of available offer in Pickiddo Platform</p>
            <CCol sm="12" class="mt-2 mb-3">
              <CRow>
                <CCol
                  v-for="(item, index) in news.slice(0, 4)"
                  v-bind:key="item.Id"
                  sm="3"
                >
                  <a :href="GoToLink(index)">
                    <div class="text-center p-2">
                      <img
                        style="max-width: 100%; border-radius: 10px; object-fit: cover;"
                        :src="getPic(index)"
                      />
                    </div>
                  </a>
                </CCol>
              </CRow>
            </CCol>
          </CCard>
        </CCol>
      </CRow>
    </CCol>
  </div>
</template>


<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
  },
  data() {
    return {
      backgroundUrl,
      user: {},
      studentProfile: {},
      news: [],
      student: [],
      childs: [],
      studentProfileAuthorize: "",
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetNews();
      this.GetUserProfile();
      this.GetListChild();
      this.GetUserStudent();
      this.GetAuthorizeProfile();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            console.log(":testing" + this.user.id);
            this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetNews();
            this.GetUserProfile(this.user.id);
            this.GetUserStudent(this.user.id);
            
          }
        });
    },
    GetUserProfile() {
      this.$API
        .get(this.$ParentProfile + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfile = response.data;
          }
        });
    },
    // GetUserStudent() {
    //   this.$API
    //     .get(this.$StudentListAuthorize + "?userId=" + this.user.id, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.student = response.data;
    //         this.photoURL =
    //           "https://pickiddo.com" + this.studentProfile.filepath;
    //       }
    //     });
    // },
    GetNews() {
      this.$API.get(this.$News, { withCredentials: true }).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.news = response.data;
          this.getPic(this.news.urlImage);
          this.GoToLink(this.news.Url);
        }
      });
    },
    GetListChild() {
      this.$API
        .get(this.$StudentListAuthorize + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
            this.getPicChild(this.childs);
          }
        });
    },
    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    getPic(index) {
      return this.news[index].urlImage;
    },
    getPicChild(index) {
      return "https://pickiddo.com" + this.childs.Students[index].profileImagePath;
    },
    GoToLink(index) {
      return this.news[index].Url;
    },
      GoToPageRegisterStudent() {
      this.$router.push("/RegisterStudent");
    },
  },
};
</script>